import React from "react";
import { Link } from "react-router-dom";
import logo from "../images/logo.png";
// import {Link} from "react-router-dom"

const Home = () => {
  return (
    <div
      className="cmn-bg"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="text-center">
              <h2 className="text-uppercase">
                EXPERIENCE SAP ANNUAL DAY 2020 AT
              </h2>
              <Link to="/">
                <img src={logo} alt="logo" className="logo" />
              </Link>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Link
                  to="/register"
                  className="register-btn text-uppercase"
                  style={{ margin: "0", marginRight: "20px" }}
                >
                  Register
                </Link>
                <Link
                  to="/login"
                  className="register-btn text-uppercase"
                  style={{ margin: "0" }}
                >
                  login
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
